import { ele } from "cables-shared-client";
import api from "./api.js";
import web from "./index.js";

export default class Login
{
    constructor()
    {
        const elSignup = ele.byClass("tab_content_signup");
        const elFn = ele.byId("firstname");
        if (elFn && elSignup)
        {
            ele.byId("firstname").style.zIndex = -100;
            ele.byId("firstname").style.position = "absolute";
        }
    }

    ajaxLogin()
    {
        const data = {
            "username": ele.byId("login_username").value,
            "password": ele.byId("login_password").value,
        };

        api.post(
            "loginajax",
            data,
            (res) =>
            {
                if (res.success)
                {
                    let redir = document.location.pathname;
                    const successRedir = ele.byId("successRedir");
                    if (successRedir && successRedir.value) redir = successRedir.value;
                    if (!redir) redir = "/home";
                    window.location.href = redir;
                }
                else
                {
                    let msg = "Login failed";

                    if (res.error) msg += ": " + res.error + "";

                    const errorsEle = ele.byQuery(".errors_login");
                    errorsEle.style.display = "block";
                    errorsEle.innerText = msg;
                }
            },
            (res) =>
            {
                const errorsEle = ele.byQuery(".errors_login");
                errorsEle.style.display = "block";
                errorsEle.innerText = "Something went wrong... No success";
            },
        );
    }

    signup()
    {
        const data = {
            "username": ele.byId("username").value,
            "firstname": ele.byId("firstname").value,
            "password": ele.byId("password").value,
            "email": ele.byId("theemail").value,
            "newsletter": document.getElementById("newslettercheckbox").checked,
        };

        const secretEle = ele.byId("secret");
        if (secretEle)
        {
            data.secred = secretEle.value;
        }

        if (document.getElementById("privacycheckbox").checked)
        {
            ele.byQuery(".errors_signup").style.display = "none";
            ele.byQuery(".errors_signup").innerText = "";
        }
        else
        {
            ele.byQuery(".errors_signup").style.display = "block";
            ele.byQuery(".errors_signup").innerText = "Please read and accept the privacy policy";
            return;
        }

        api.post(
            "user/signup",
            data,
            (res) =>
            {
                if (res.status == "SUCCESS" && res.goto)
                {
                    ele.byQuery(".tab_content_signup").innerHTML = "<div class=\"text-center\">Thank you for signing up! <br/><br/>Please check your inbox to confirm your email. <br/>After that you can <a href=\"/login\">login</a></div>";
                }
                else
                {
                    ele.byQuery(".errors_signup").style.display = "block";
                    ele.byQuery(".errors_signup").innerText = "";
                    ele.byQuery(".errors_signup").innerText = "Something went wrong... No success " + res.errors;
                }
            },
            (res) =>
            {
                ele.byQuery(".errors_signup").style.display = "block";
                ele.byQuery(".errors_signup").innerText = "";

                if (res.errors && res.errors.length > 0)
                {
                    if (!res.errors.includes("MAINTENANCE_MODE"))
                    {
                        ele.byQuery(".errors_signup").innerHTML = "Please check your data:<br/><br/>";
                    }

                    if (res.errors)
                    {
                        for (const i in res.errors)
                        {
                            if (res.errors[i] === "EMAIL_INVALID") ele.byQuery(".errors_signup").innerHTML += "- This is not a valid email<br/>";
                            else if (res.errors[i] === "PASSWORD_TOO_SHORT") ele.byQuery(".errors_signup").innerHTML += "- Please use a longer password<br/>";
                            else if (res.errors[i] === "USERNAME_TOO_SHORT") ele.byQuery(".errors_signup").innerHTML += "- Please use a longer username<br/>";
                            else if (res.errors[i] === "EMAIL_EXISTS") ele.byQuery(".errors_signup").innerHTML += "- This email is already registered<br/>";
                            else if (res.errors[i] === "USER_EXISTS") ele.byQuery(".errors_signup").innerHTML += "- Username already exists<br/>";
                            else if (res.errors[i] === "INVALID CHARACTERS") ele.byQuery(".errors_signup").innerHTML += "- Please do not use any special characters or spaces in your username<br/>";
                            else if (res.errors[i] === "ERROR_USERNAME_EQUALS_EMAIL") ele.byQuery(".errors_signup").innerHTML += "- Your username cannot be your email-address<br/>";
                            else if (res.errors[i] === "MAINTENANCE_MODE") ele.byQuery(".errors_signup").innerHTML += "cables is currently in maintenance mode,<br/>please try again later";
                            else ele.byQuery(".errors_signup").innerHTML += "- " + res.errors[i] + "<br/>";
                        }
                    }
                }
                else
                {
                    ele.byQuery(".errors_signup").innerText = "something went wrong...";
                }
            },
        );
    }

    setResetPassword()
    {
        const data = {
            "password": ele.byId("password").value,
            "hash": ele.byId("hash").value,
        };

        api.post(
            "user/setResetPassword",
            data,
            (res) =>
            {
                if (res.success)
                {
                    ele.byQuery(".errors").style.display = "block";
                    ele.byQuery(".errors").innerText = "";
                    ele.byQuery(".tab_content_signup").innerHTML = "new password set!<br/><br/><a href=\"/login\">login now</a>";
                }
                else
                {
                    ele.byQuery(".errors").style.display = "block";
                    ele.byQuery(".errors").innerText = "Something went wrong... No success";
                }
            },
            (res) =>
            {
                ele.byQuery(".errors").style.display = "block";
                ele.byQuery(".errors").innerText = "";

                if (res.errors && res.errors.length > 0)
                {
                    if (!res.errors.includes("USER_LOGGED_IN"))
                    {
                        ele.byQuery(".errors").innerHTML = "please check your data:<br/><br/>";
                    }

                    for (const i in res.errors)
                    {
                        if (res.errors[i] === "USER_LOGGED_IN")
                        {
                            ele.byQuery(".errors").innerHTML += "you are currently logged in, <a href='/logout'>log out</a> to reset your password";
                        }
                        else
                        {
                            ele.byQuery(".errors").innerHTML += "- " + res.errors[i] + "<br/>";
                        }
                    }
                }
                else
                {
                    ele.byQuery(".errors").innerHTML += "something went wrong...";
                }
            }
        );
    }

    unsubscribeNewsletter(subscriberId, button)
    {
        web.buttons.startSavingAnimButton(button);
        const resultEle = document.getElementById("result");
        if (resultEle)
        {
            ele.hide(resultEle);
            resultEle.classList.remove("error");
        }
        api.get("user/unsubscribe/newsletter/" + subscriberId, {}, () =>
        {
            web.buttons.stopSavingAnimButton(button);
            if (resultEle)
            {
                resultEle.innerText = "Successfully unsubscribed!";
                resultEle.classList.add("info");
                ele.show(resultEle);
            }
        }, (e) =>
        {
            web.buttons.stopSavingAnimButton(button, false, true);
            if (resultEle)
            {
                resultEle.innerText = "Failed to unsubscribe: " + e.msg;
                resultEle.classList.add("error");
                ele.show(resultEle);
            }
        });
    }

    resetPassword()
    {
        const data = {
            "email": ele.byId("email").value,
        };

        api.post(
            "user/resetPassword",
            data,
            (res) =>
            {
                if (res.success)
                {
                    ele.byQuery(".errors").style.display = "block";
                    ele.byQuery(".errors").innerText = "";
                    ele.byQuery(".errors").innerText = "password reset email sent!";

                    ele.byId("resetpasswdbutton").style.display = "none";
                    ele.byId("email").style.display = "block";
                }
                else
                {
                    ele.byQuery(".errors").style.display = "block";
                    ele.byQuery(".errors").innerText = "";
                    ele.byQuery(".errors").innerText = "Something went wrong... No success";
                }
            },
            (res) =>
            {
                ele.byQuery(".errors").style.display = "block";
                ele.byQuery(".errors").innerText = "";

                if (res.errors && res.errors.length > 0)
                {
                    if (!res.errors.includes("USER_LOGGED_IN"))
                    {
                        ele.byQuery(".errors").innerHTML = "please check your data:<br/><br/>";
                    }

                    for (const i in res.errors)
                    {
                        if (res.errors[i] === "USER_LOGGED_IN")
                        {
                            ele.byQuery(".errors").innerHTML += "you are currently logged in, <a href='/logout'>log out</a> to reset your password";
                        }
                        else
                        {
                            ele.byQuery(".errors").innerHTML += "- " + res.errors[i] + "<br/>";
                        }
                    }
                }
                else
                {
                    ele.byQuery(".errors").innerHTML += "something went wrong...";
                }
            },
        );
    }

    resendConfirmEmail()
    {
        const data = {
            "email": ele.byId("email").value,
        };

        api.post(
            "send_confirm/",
            data,
            (res) =>
            {
                if (res.success)
                {
                    ele.byId("result").innerText = "password reset email sent!";
                    ele.byId("form").style.display = "none";
                }
                else
                {
                    ele.byId("result").innerText = "Something went wrong... No success";
                    ele.byId("form").style.display = "none";
                }
            },
            (res) =>
            {
                ele.byId("result").innerText = "Something went wrong... No success";
                ele.byId("form").style.display = "none";
            }
        );
    }
}
